module.exports = __webpack_public_path__ + "img/platform2.6e73e564.png";